import { render, staticRenderFns } from "./ChangeNamePayment.vue?vue&type=template&id=35b78273&scoped=true"
import script from "./ChangeNamePayment.vue?vue&type=script&lang=js"
export * from "./ChangeNamePayment.vue?vue&type=script&lang=js"
import style0 from "./ChangeNamePayment.vue?vue&type=style&index=0&id=35b78273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b78273",
  null
  
)

export default component.exports